// Página 404 explícita. Antes el catch-all del router redirigía en silencio a
// /app, lo que ocultaba enlaces rotos. Ahora muestra un 404 con salida clara.
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--color-base)] px-6 text-center">
      <div className="font-[var(--font-mono)] text-5xl font-bold text-[var(--color-text-muted)]">404</div>
      <div className="text-[16px] font-semibold text-[var(--color-text-primary)]">
        No encontramos esta página
      </div>
      <p className="max-w-sm text-[13px] text-[var(--color-text-secondary)]">
        El enlace puede estar roto o la página fue movida.
      </p>
      <button
        type="button"
        onClick={() => navigate("/app/cases")}
        className="rounded-[var(--radius-lg)] border border-[var(--color-border-strong)] px-4 py-2 text-[13px] font-medium text-[var(--color-text-primary)] transition-colors hover:bg-[var(--color-surface-2)]"
      >
        Ir a la biblioteca
      </button>
    </div>
  );
}
